export default __webpack_public_path__ + "static/media/calendar-white.2bb7663a.svg";